export default {
  "nl": {
    "document": {
      "actions": {
        "delete": "Verwijderen",
        "deleteMultipleDocuments": "Verwijder...",
        "delete_cancel": "Annuleren",
        "delete_documents": "Verwijder document | Verwijder documenten",
        "download": "Downloaden",
        "edit": "Bewerken",
        "hideDetails": "Verberg details",
        "new": "Upload documenten",
        "share": "Deel",
        "shareWithProjectPartners": "Delen (ongedaan maken) met projectpartners...",
        "share_documents": "Deel document | Deel documenten",
        "share_with": "Deel met...",
        "showDetails": "Toon details",
        "submit": "Opslaan",
        "tickBoxesDeletion": "Selecteer de documenten die je wil verwijderen.",
        "unshare": "Delen ongedaan maken",
        "unshare_documents": "Document delen ongedaan maken | Documenten delen ongedaan maken"
      },
      "attachable_types": {
        "building": "Gebouw",
        "decisions": "Beslissingen",
        "installment": "Betalingsschijf",
        "issue": "Punt",
        "lot": "Lot",
        "phase": "Fase",
        "project": "Project",
        "tickets": "Gesprekken",
        "unit": "Unit"
      },
      "attributes": {
        "category": "Categorie",
        "file_ext": "Bestandstype",
        "file_size": "Bestandsgrootte",
        "name": "Naam",
        "uploaded_at": "Geüpload om",
        "uploaded_by": "Geüpload door"
      },
      "category": {
        "admin": "Administratie",
        "as_built": "Postinterventiedossier",
        "brochure": "Brochure",
        "decision": "Beslissing",
        "image": "Afbeelding",
        "invoice": "Factuur",
        "legal": "Wettelijk",
        "manual": "Handleiding",
        "other": "Overige",
        "plan": "Plan",
        "quote": "Offerte",
        "ticket": "Gesprek"
      },
      "labels": {
        "allDocuments": "All documenten",
        "allUnits": "Alle Units",
        "building": "gebouw",
        "categories": "Categorieën",
        "created": "Aangemaakt op",
        "customer": "Klant",
        "decision": "beslissing",
        "decisionsAndProposals": "Beslissingen en Voorstellen",
        "disclaimerDocumentsCustomer": "Zoek of upload documenten met betrekking tot beslissing {decision_name}",
        "documents": "Documenten",
        "documents_all": "Alle documenten",
        "documents_plan": "Plandocumenten",
        "documents_plan_explainer": "Documenten die zijn toegevoegd aan de documentenmap van unit {unit_name} met de categorie 'Plan', worden automatisch toegevoegd aan deze beslissing en zijn toegankelijk voor alle partners.",
        "editDocument": "Wijzigen Document",
        "files": "Bestanden {level_name}",
        "filter": "Filteren",
        "folders": "Folders",
        "goToUnitDocumentsFolder": "Ga naar de {unit_name} documentenmap",
        "goToUnitsFolder": "Deze pagina bevat alleen beslissingsdocumenten. Ga naar de unit folder om de andere documenten te zien.",
        "include_original_documents": "Toon de te ondertekenen documenten",
        "includesProposalAndDocuments": "Bevat voorsteldocumenten en beslissingsdocumenten",
        "info": "Documenten met betrekking tot jouw woning zullen binnenkort hier beschikbaar zijn.",
        "locked": "Dit document behoort tot de categorie 'Plan' en kan alleen worden verwijderd uit de map met unitdocumenten",
        "lockedDocumentApprovedProposal": "Dit document hoort bij een goedgekeurd voorstel en kan niet worden verwijderd",
        "lockedDocumentDelete": "Dit document kan niet worden verwijderd",
        "lot": "lot",
        "more_info": "Meer info",
        "name_asc": "Naam A->Z",
        "name_desc": "Naam Z->A",
        "next": "Volgende",
        "noCustomer": "Nog geen klant toegewezen",
        "noPreviewPossible": "Geen voorbeeld mogelijk voor dit documenttype. Probeer het eerst te downloaden.",
        "no_plan_documents": "Geen plandocumenten toegevoegd aan de unitfolder",
        "onlyUnitDocumentsSharedWithProjectPartners": "Alleen unitdocument kunnen gedeeld worden met projectpartners",
        "only_approved_proposals": "Alleen documenten van goedgekeurde voorstellen worden weergegeven",
        "original_documents_info": "Toon de originele niet-ondertekende versies van de documenten die ondertekend moeten worden.",
        "owner": "Eigenaar",
        "page": "Bladzijde",
        "phase": "fase",
        "previous": "Vorig",
        "project": "project",
        "project_partners": "Projectpartners",
        "proposal": "voorstel",
        "search_document": "Zoek document",
        "shareWith": "Deel met",
        "sharedWithClient": "Gedeeld met {client_name}",
        "sharedWithProjectPartners": "Gedeeld met projectpartners",
        "shared_with": "Gedeeld met",
        "sharingSettingsDecision": "Binnen deze beslissing",
        "sharingSettingsProject": "In dit project",
        "showDocumentsFor": "Toon documenten voor",
        "showLevel": "Dit is een {level}document",
        "signed": "Ondertekend op",
        "signedBy": "Ondertekend door",
        "source": "Oorsprong",
        "subtitleSharingDocuments": "Het geselecteerde document zal beschikbaar zijn voor projectpartners | De geselecteerde documenten zullen beschikbaar zijn voor projectpartners",
        "subtitleUnsharingDocuments": "Het geselecteerde document zal niet meer beschikbaar zijn voor projectpartners | De geselecteerde documenten zullen niet meer beschikbaar zijn voor projectpartners",
        "ticket": "conversatie",
        "unit": "unit",
        "unitFolder": "Ga naar unitdocumenten",
        "updated_at_asc": "Oudste eerst",
        "updated_at_desc": "Nieuwste eerst",
        "upload_failed": "1 of meer bestanden kunnen niet worden geüpload. Verwijder ze of probeer opnieuw te uploaden.",
        "uploadedBy": "Geüpload door",
        "visibleFor": "Gedeeld met",
        "warningNotShared": "Oeps! Niemand is geselecteerd. Weet je het zeker? Klik nogmaals om te bevestigen."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Je zal een notificatie-email ontvangen wanneer een nieuw document beschikbaar is. Bekijk en download ze hier.",
            "title": "Nog geen documenten beschikbaar"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Het uploaden van documenten stuurt automatisch notificatie-emails naar relevante klanten.",
            "title": "Geen documenten voor {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Navigeer door de projectstructuur om de documenten van een unit te zien",
            "title": "Ga naar een unit om documenten te bekijken"
          },
          "new": {
            "subtitle": "Het uploaden van documenten stuurt automatisch notificatie-emails.",
            "title": "Nog geen documenten beschikbaar voor deze beslissing"
          },
          "none": {
            "subtitle": "Hier zal je documenten terugvinden voor {unit}",
            "title": "Nog geen documenten"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Document succesvol verwijderd | Documenten succesvol verwijderd",
        "bulk_upload": "Document succesvol geüpload | Documenten succesvol geüpload",
        "update": "{count} document succesvol gewijzigd | {count} documenten succesvol gewijzigd",
        "upload_success": "{count} document werd succesvol geüpload | {count} document(en) werden succesvol geüpload"
      },
      "validation": {
        "need_category": "Categorie vereist",
        "need_category_all": "Alle documenten moeten een categorie hebben",
        "selectDocument": "Selecteer ten minste 1 document"
      }
    }
  }
}